import { render, staticRenderFns } from "./CatalogFiltersBox.vue?vue&type=template&id=60b61cbc&"
import script from "./CatalogFiltersBox.js?vue&type=script&lang=js&"
export * from "./CatalogFiltersBox.js?vue&type=script&lang=js&"
import style0 from "./CatalogFiltersBox.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports